import React from 'react';
import { Link, RichText } from 'prismic-reactjs';
import { linkResolver } from '../../../prismic-configuration';

const PostSidebar = () => {
  return null;
}

export default PostSidebar
